import { LOCALES, LOCALE_STORAGE_KEY } from './constants';

export function getStoredLocale() {
  try {
    const value = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (value && LOCALES.includes(value)) {
      return value;
    }
  } catch (_) {
    // ignore storage errors
  }
  return null;
}

export function setStoredLocale(locale) {
  if (!LOCALES.includes(locale)) {
    return;
  }
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (_) {
    // ignore storage errors
  }
}
